import type { Response } from '~/types/api/v2'
import type { DocumentsMetaTag } from '~/types'

import { useFetchWithDefaults } from '~/composables/api/useFetchWithDefaults'

import { type DocumentIdentifier, getUrlById as getDocumentByIdUrl } from '../useFetchDocument'

export const useFetchDocumentTag = () => {
  const getUrl = (documentId: string) => `${getDocumentByIdUrl(documentId)}/tags`

  const { put } = useFetchWithDefaults()

  const update = ({
    workspaceId,
    documentId,
    tags,
  }: DocumentIdentifier & { tags: string[] }) => {
    const body = {
      tags,
    } satisfies App.Data.Payloads.Documents.UpdateTagsPayload

    return put<Response<DocumentsMetaTag[]>>({
      url: getUrl(documentId),
      workspaceId,
      fetchOptions: {
        body,
      },
    })
  }

  return {
    update,
  }
}
